import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import Scroll, { scroller } from 'react-scroll';
import { FormattedMessage } from 'react-intl';
import tracking from '../services/Tracking';

class SeeResultsButton extends React.Component {

  constructor(props) {
    super(props);

    this.handleOnClick = this.handleOnClick.bind(this);
  }

  componentDidMount() {
    const { isVisible, isScrollIndicatorVisible } = this.props;

    if(isVisible && !isScrollIndicatorVisible) {
      this.scrollIntoView();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { isVisible, isScrollIndicatorVisible } = nextProps;

    if(isVisible && !isScrollIndicatorVisible) {
      this.scrollIntoView();
    }
  }

  scrollIntoView() {
    setTimeout(()=>{
      const element = document.querySelector('[name=resultButton]');
      if(element){
        scroller.scrollTo('resultButton', {
          smooth: true,
          offset: element.getBoundingClientRect().height - window.innerHeight + 50,
          duration: 900,
        });
      }
    }, 500);
  }

  handleOnClick() {
    tracking.page('showersystem-configurator/finish');
  }

  render() {
    const { isVisible } = this.props;

    return (
      <Scroll.Element name="resultButton">
        {isVisible && (
          <div className="row">
            <div className="col text-center">
              <Link
                to="/lv_lv/watersystems/result"
                onClick={this.handleOnClick}
                className="btn btn-primary button button--showResultPage"
              >
                <FormattedMessage id="configurator.button.seeResults" />
              </Link>
            </div>
          </div>
        )}
      </Scroll.Element>
    );
  }
}

SeeResultsButton.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  isScrollIndicatorVisible: PropTypes.bool.isRequired,
};

SeeResultsButton.defaultProps = {
  isVisible: false,
  isScrollIndicatorVisible: false,
};

function mapStateToProps(state) {
  return {
    isVisible: state.configurator.showResults,
    isScrollIndicatorVisible: state.configurator.showScrollIndicator,
  };
}

export default connect(mapStateToProps)(SeeResultsButton);



// WEBPACK FOOTER //
// ./src/components/SeeResultsButton.js